/**
 * Auth API origin.
 * Dev: empty → request cùng origin (localhost:3000) rồi setupProxy chuyển tiếp,
 * tránh CORS vì api.toolvipllwin.com chỉ allow https://toolvipllwin.com.
 */
export function getApiBase(): string {
  if (process.env.NODE_ENV === "development") return "";
  return String(process.env.REACT_APP_URL_API || "").replace(/\/$/, "");
}

/** Casino/predict API — dev đi qua proxy `/predict` để tránh CORS. */
export function getCasinoApiBase(): string {
  if (process.env.NODE_ENV === "development") return "";
  return String(process.env.REACT_APP_URL_API_CASINO || "").replace(/\/$/, "");
}
